import { L as LICENSE_MIN_PRICE, a as LICENSE_MAX_PRICE } from "../../../../chunks/private.js";
import { j as json } from "../../../../chunks/index2.js";
import range from "lodash/range.js";
const GET = () => {
  return json(range(Number(LICENSE_MIN_PRICE), Number(LICENSE_MAX_PRICE) + 1));
};
export {
  GET
};
